import { render, staticRenderFns } from "./TheCadastro.vue?vue&type=template&id=687c4e58&scoped=true"
import script from "./TheCadastro.vue?vue&type=script&lang=js"
export * from "./TheCadastro.vue?vue&type=script&lang=js"
import style0 from "./TheCadastro.vue?vue&type=style&index=0&id=687c4e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c4e58",
  null
  
)

export default component.exports